import React from 'react';
import { Database, Shield, Bell, UserCheck } from 'lucide-react';
import PolicySectionCard from '@/components/policy/PolicySectionCard';
import PageHeader from '@/components/layout/PageHeader';
import PolicyLayout from '@/components/policy/PolicyLayout';
import { motion } from 'framer-motion';

const DataProcessingAgreement = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    show: { y: 0, opacity: 1 }
  };

  return (
    <PolicyLayout>
      <PageHeader
        title="Data Processing Agreement"
        description="Last updated: April 11, 2025"
        icon={<Database className="w-8 h-8 text-primary" />}
      />

      {/* Cards Grid */}
      <motion.div 
        className="space-y-6"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.div variants={item}>
          <PolicySectionCard
            title="Overview"
            icon={Database}
            variant="amber"
          >
            <p>This Data Processing Agreement applies when Cibeto Technologies Pvt Ltd processes personal data on behalf of a customer or partner under Edaptica.</p>
          </PolicySectionCard>
        </motion.div>

        <motion.div variants={item}>
          <PolicySectionCard
            title="Terms Include"
            icon={Shield}
            variant="indigo"
          >
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Data Controller & Processor Roles:</strong> Client is the controller; Edaptica is the processor</li>
              <li><strong>Scope of Processing:</strong> Only as necessary to provide Edaptica services</li>
              <li><strong>Security Measures:</strong> SSL encryption, access control, regular audits</li>
              <li><strong>Subprocessors:</strong> All subprocessors are GDPR-compliant</li>
            </ul>
          </PolicySectionCard>
        </motion.div>

        <motion.div variants={item}>
          <PolicySectionCard
            title="Data Breach Notification"
            icon={Bell}
            variant="cyan"
          >
            <p>We will notify the controller within 72 hours of becoming aware of a breach.</p>
          </PolicySectionCard>
        </motion.div>

        <motion.div variants={item}>
          <PolicySectionCard
            title="Contact"
            icon={UserCheck}
            variant="emerald"
          >
            <p>To execute a signed DPA, contact: legal@edaptica.com</p>
          </PolicySectionCard>
        </motion.div>
      </motion.div>
    </PolicyLayout>
  );
};

export default DataProcessingAgreement;
